<template>
  <div class="modal modal-show" @click.self="cancel">
  <transition name="modaltransition">
    <div class="modal-content">
      <div class="logout-form">
        <div class="label-logout">{{ $t('logout.subtitle') }}</div>
        <div class="button button-primary" @click.prevent="logout">logout</div>
        <div class="button button-default" @click.prevent="cancel">cancel</div>
      </div>
    </div>
  </transition>
  </div>
</template>

<script>
  import { api } from "../../config";
  import {mapActions} from "vuex";

  export default {
    name: "logoutmodal",
    methods: {
      logout() {
        this.$emit('close')
        
        this.$store.dispatch('showLoading', true)
        //TODO: 消えてくれない
        // window.sessionStorage.removeItem(appName);
        axios.post(api.logout).then(() => {
          this.$store.dispatch('unsetAuthUser')
          this.$store.dispatch('unsetProfile')
          this.$store.dispatch('unsetLanguage')
          this.$store.dispatch('unsetLessons')
          this.$store.dispatch('unsetLessonData')
          this.$store.dispatch('unsetLessonContent')
          .then(() => {
            
            this.$store.dispatch('showLoading', false);
            this.$router.push({name: 'login'});
          });
        });
      },
      cancel() {
        this.$emit('close')
      }
    }
  }
</script>
